import { LandingImage } from './LandingImage';
import { MessageStates } from './MessageStates';
import styles from './OneAgentSection.module.css';
import { PrimaryCta } from './PrimaryCta';

type OneAgentSectionProps = {
	onCta: () => void;
};

export const OneAgentSection = ({ onCta }: OneAgentSectionProps) => (
	<section className={styles.section}>
		<div className={styles.frame}>
			<LandingImage
				src="/landing/cloud-soft.png"
				alt=""
				className={styles.cloudA}
			/>
			<LandingImage
				src="/landing/cloud-wisp.png"
				alt=""
				className={styles.cloudB}
			/>
			<LandingImage
				src="/landing/cloud-wisp.png"
				alt=""
				className={styles.cloudC}
			/>
			<div className={styles.inner}>
				<div className={styles.copyBlock}>
					<div className={styles.headingGroup}>
						<span className={styles.eyebrow}>ONE AGENT, EVERY ROLE</span>
						<h2 className={styles.heading}>
							Agents do the work, even when you&rsquo;re not at your desk.
						</h2>
					</div>
					<p className={styles.sub}>
						Project Bridgeway deploys custom subagents that text you. Approve,
						redirect, or ask questions without ever opening the app.
					</p>
				</div>
				<div className={styles.statesWrap}>
					<MessageStates />
				</div>
				<div className={styles.cta}>
					<PrimaryCta
						onClick={onCta}
						variant="light"
						label="Start saving time"
					/>
				</div>
			</div>
		</div>
	</section>
);
